module.exports = __webpack_public_path__ + "img/dog_11878.5c12b513.png";